import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { EventEmitter, Component, Input, ElementRef, ViewChild, Output, ViewEncapsulation, Directive, ContentChild, NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input'
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSelectModule} from '@angular/material/select';

import {MatMenuTrigger, MatMenuModule} from '@angular/material/menu';
import {MatTabsModule} from '@angular/material/tabs';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatChipsModule} from '@angular/material/chips';
import {MatTableModule} from '@angular/material/table';

import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDialogModule} from '@angular/material/dialog';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/material/menu';
import * as ɵngcc3 from '@angular/material/tabs';
import * as ɵngcc4 from '@angular/material/datepicker';
import * as ɵngcc5 from '@angular/material/checkbox';
import * as ɵngcc6 from '@angular/forms';
import * as ɵngcc7 from '@angular/material/input';
import * as ɵngcc8 from '@angular/material/progress-spinner';
import * as ɵngcc9 from '@angular/material/radio';

const _c0 = ["filterMenu"];
function PwoFilterComponent_span_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PwoFilterComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵlistener("click", function PwoFilterComponent_span_0_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); ctx_r8.visible = true; return ɵngcc0.ɵɵresetView(ctx_r8.open()); });
    ɵngcc0.ɵɵtemplate(1, PwoFilterComponent_span_0_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function PwoFilterComponent_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PwoFilterComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵlistener("click", function PwoFilterComponent_span_1_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r11.visible = true); });
    ɵngcc0.ɵɵtemplate(1, PwoFilterComponent_span_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(6);
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("matMenuTriggerFor", _r5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function PwoFilterComponent_button_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PwoFilterComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("menuOpened", function PwoFilterComponent_button_2_Template_button_menuOpened_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r14.visible = true); });
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelement(2, "div", 11);
    ɵngcc0.ɵɵtemplate(3, PwoFilterComponent_button_2_ng_container_3_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(6);
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵclassProp("active", ctx_r2.visible);
    ɵngcc0.ɵɵproperty("matMenuTriggerFor", _r5);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function PwoFilterComponent_ng_template_3_ng_container_0_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 15);
    ɵngcc0.ɵɵtext(1, "keyboard_arrow_down");
    ɵngcc0.ɵɵelementEnd();
} }
function PwoFilterComponent_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", null, 13);
    ɵngcc0.ɵɵprojection(3, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, PwoFilterComponent_ng_template_3_ng_container_0_i_4_Template, 2, 0, "i", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r19 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", _r19.childNodes.length === 0);
} }
function PwoFilterComponent_ng_template_3_ng_container_1_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 15);
    ɵngcc0.ɵɵtext(1, "keyboard_arrow_up");
    ɵngcc0.ɵɵelementEnd();
} }
function PwoFilterComponent_ng_template_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", null, 16);
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, PwoFilterComponent_ng_template_3_ng_container_1_i_4_Template, 2, 0, "i", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r21 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", _r21.childNodes.length === 0);
} }
function PwoFilterComponent_ng_template_3_ng_container_2_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 15);
    ɵngcc0.ɵɵtext(1, "filter_list");
    ɵngcc0.ɵɵelementEnd();
} }
function PwoFilterComponent_ng_template_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", null, 17);
    ɵngcc0.ɵɵprojection(3, 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, PwoFilterComponent_ng_template_3_ng_container_2_i_4_Template, 2, 0, "i", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r23 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", _r23.childNodes.length === 0);
} }
function PwoFilterComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, PwoFilterComponent_ng_template_3_ng_container_0_Template, 5, 1, "ng-container", 12);
    ɵngcc0.ɵɵtemplate(1, PwoFilterComponent_ng_template_3_ng_container_1_Template, 5, 1, "ng-container", 12);
    ɵngcc0.ɵɵtemplate(2, PwoFilterComponent_ng_template_3_ng_container_2_Template, 5, 1, "ng-container", 12);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.visible && !ctx_r4.filter.isApplied);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.visible && !ctx_r4.filter.isApplied);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.filter.isApplied);
} }
function PwoFilterComponent_div_7_lib_date_filter_1_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-date-filter", 20);
    ɵngcc0.ɵɵlistener("close", function PwoFilterComponent_div_7_lib_date_filter_1_Template_lib_date_filter_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r29); const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r28.close()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("filter", ctx_r25.filter)("filterService", ctx_r25.filterService);
} }
function PwoFilterComponent_div_7_lib_single_select_filter_2_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-single-select-filter", 20);
    ɵngcc0.ɵɵlistener("close", function PwoFilterComponent_div_7_lib_single_select_filter_2_Template_lib_single_select_filter_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r30.close()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("filter", ctx_r26.filter)("filterService", ctx_r26.filterService);
} }
function PwoFilterComponent_div_7_lib_multi_select_filter_3_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-multi-select-filter", 20);
    ɵngcc0.ɵɵlistener("close", function PwoFilterComponent_div_7_lib_multi_select_filter_3_Template_lib_multi_select_filter_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r32.close()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("filter", ctx_r27.filter)("filterService", ctx_r27.filterService);
} }
function PwoFilterComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵlistener("click", function PwoFilterComponent_div_7_Template_div_click_0_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵtemplate(1, PwoFilterComponent_div_7_lib_date_filter_1_Template, 1, 2, "lib-date-filter", 19);
    ɵngcc0.ɵɵtemplate(2, PwoFilterComponent_div_7_lib_single_select_filter_2_Template, 1, 2, "lib-single-select-filter", 19);
    ɵngcc0.ɵɵtemplate(3, PwoFilterComponent_div_7_lib_multi_select_filter_3_Template, 1, 2, "lib-multi-select-filter", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("pwo-styles", ctx_r6.hasStyles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.is(ctx_r6.filter, ctx_r6.filterTypes.DateFilter));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.is(ctx_r6.filter, ctx_r6.filterTypes.ValueFilter));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.is(ctx_r6.filter, ctx_r6.filterTypes.MultiValueFilter));
} }
const _c1 = ["*", [["", "icon-closed", ""]], [["", "icon-opened", ""]], [["", "icon-applied", ""]]];
const _c2 = ["*", "[icon-closed]", "[icon-opened]", "[icon-applied]"];
const _c3 = ["tabGroup"];
function MultiSelectFilterComponent_div_6_mat_checkbox_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-checkbox", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function MultiSelectFilterComponent_div_6_mat_checkbox_3_Template_mat_checkbox_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r4.addToFilter = $event); });
    ɵngcc0.ɵɵtext(1, " Add selection to filter ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.addToFilter);
} }
function MultiSelectFilterComponent_div_6_mat_checkbox_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-checkbox", 14);
    ɵngcc0.ɵɵlistener("click", function MultiSelectFilterComponent_div_6_mat_checkbox_4_Template_mat_checkbox_click_0_listener($event) { return $event.stopPropagation(); })("change", function MultiSelectFilterComponent_div_6_mat_checkbox_4_Template_mat_checkbox_change_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r9); const f_r6 = restoredCtx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView($event ? ctx_r8.selection.toggle(f_r6) : null); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const f_r6 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("checked", ctx_r3.selection.isSelected(f_r6));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", f_r6, " ");
} }
function MultiSelectFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9)(1, "mat-checkbox", 10);
    ɵngcc0.ɵɵlistener("change", function MultiSelectFilterComponent_div_6_Template_mat_checkbox_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView($event && ctx_r10.toggleAll()); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, MultiSelectFilterComponent_div_6_mat_checkbox_3_Template, 2, 1, "mat-checkbox", 11);
    ɵngcc0.ɵɵtemplate(4, MultiSelectFilterComponent_div_6_mat_checkbox_4_Template, 2, 2, "mat-checkbox", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("checked", ctx_r0.allSelected)("indeterminate", ctx_r0.fewSelected);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" Select all ", ctx_r0.searchTerm.length > 0 ? "search results" : "", " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.searchTerm.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.filterValues);
} }
function MultiSelectFilterComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelement(1, "mat-spinner", 16);
    ɵngcc0.ɵɵelementEnd();
} }
function SingleSelectFilterComponent_div_6_mat_radio_button_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-radio-button", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const f_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("value", f_r3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.filter.transform(f_r3), " ");
} }
function SingleSelectFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9)(1, "mat-radio-group", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function SingleSelectFilterComponent_div_6_Template_mat_radio_group_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.selected = $event); });
    ɵngcc0.ɵɵtemplate(2, SingleSelectFilterComponent_div_6_mat_radio_button_2_Template, 2, 2, "mat-radio-button", 11);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selected);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.filterValues);
} }
function SingleSelectFilterComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function SingleSelectFilterComponent_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.clear()); });
    ɵngcc0.ɵɵelementStart(1, "i", 4);
    ɵngcc0.ɵɵtext(2, "clear");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4, "Clear");
    ɵngcc0.ɵɵelementEnd()();
} }
class PwoFilterCloudService {
    // private _search = '';
    // get search(): string {
    //   return this._search;
    // }
    // set search(search: string) {
    //   this._search = search;
    //   this.triggerFilter();
    // }
    /**
     * @param {?} getItems
     * @param {?} getFilterValues
     * @param {?=} initialLoad
     */
    constructor(getItems, getFilterValues, initialLoad = true) {
        this.data = new EventEmitter();
        this.apply = new EventEmitter();
        this.appliedFilters = {};
        this.api = { getItems, getFilterValues };
        if (initialLoad) {
            this.triggerFilter();
        }
    }
    /**
     * @param {?} filter
     * @param {?=} skipTrigger
     * @return {?}
     */
    applyFilter(filter, skipTrigger = false) {
        console.log('apply', filter);
        if (filter.isActive()) {
            // Set filter
            filter.isApplied = true;
            this.appliedFilters[filter.key] = filter;
        }
        else {
            // Delete filter
            filter.isApplied = false;
            delete this.appliedFilters[filter.key];
        }
        this.setFilterActiveClass(filter);
        this.apply.emit(filter);
        if (!skipTrigger) {
            this.triggerFilter();
        }
    }
    /**
     * @param {?} filter
     * @return {?}
     */
    getFilterValues(filter) {
        // Get records excluding this one
        /** @type {?} */
        const records = this.getRecords().filter((/**
         * @param {?} el
         * @return {?}
         */
        el => el.key !== filter.key));
        return this.api.getFilterValues(filter.toFilterRecord(), records);
    }
    /**
     * @private
     * @return {?}
     */
    getRecords() {
        return Object.values(this.appliedFilters).map((/**
         * @param {?} f
         * @return {?}
         */
        f => f.toFilterRecord()));
    }
    /**
     * @private
     * @param {?} filter
     * @return {?}
     */
    setFilterActiveClass(filter) {
        /** @type {?} */
        const el = document.querySelector('.mat-column-' + filter.key);
        if (el) {
            if (filter.isActive()) {
                el.classList.add('pwo-filter-active');
            }
            else {
                el.classList.remove('pwo-filter-active');
            }
        }
    }
    /**
     * @param {?} filter
     * @return {?}
     */
    isSet(filter) {
        return this.appliedFilters[filter.key] ? true : false;
    }
    /**
     * @return {?}
     */
    hasFilterSet() {
        return Object.values(this.appliedFilters).length > 0;
    }
    /**
     * @return {?}
     */
    clearAllFilters() {
        Object.values(this.appliedFilters).forEach((/**
         * @param {?} filter
         * @return {?}
         */
        (filter) => filter.isApplied = false));
        this.appliedFilters = {};
        this.triggerFilter();
        // Remove all filter active classes
        /** @type {?} */
        const cols = document.querySelectorAll('.pwo-filter-active');
        cols.forEach((/**
         * @param {?} col
         * @return {?}
         */
        col => col.classList.remove('pwo-filter-active')));
    }
    /**
     * If you want to set multiple filters at once, call applyFilter
     * with skipTrigger set to true (applyFilter([...], true)) and
     * call this function afterwards.
     * @return {?}
     */
    triggerFilter() {
        /** @type {?} */
        const records = this.getRecords();
        this.api.getItems(records).then((/**
         * @param {?} values
         * @return {?}
         */
        values => {
            this.data.emit(values);
        }));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Generic filter, can't be used to filter a column!
 * @abstract
 */
class Filter {
    /**
     * @param {?} key
     */
    constructor(key) {
        this.isApplied = false;
        this.key = key;
    }
}
/**
 * Use this filter to filter for a specific value in a column.
 * @template T
 */
class ValueFilter extends Filter {
    constructor() {
        super(...arguments);
        this.transform = (/**
         * @param {?} val
         * @return {?}
         */
        val => val);
    }
    /**
     * @return {?}
     */
    isActive() {
        return this.value !== undefined && this.value !== null;
    }
    /**
     * @return {?}
     */
    toFilterRecord() {
        return {
            key: this.key,
            type: 'list',
            values: [this.value]
        };
    }
}
/**
 * Use this filter to filter for multiple possible values in a column.
 * @template T
 */
class MultiValueFilter extends Filter {
    constructor() {
        super(...arguments);
        /**
         * Set this to true to set the filter even if the selected array is empty.
         */
        this.forceFilter = false;
    }
    /**
     * @return {?}
     */
    isActive() {
        return this.selected && (this.forceFilter || this.selected.length > 0);
    }
    /**
     * @return {?}
     */
    toFilterRecord() {
        return {
            key: this.key,
            type: 'list',
            values: this.selected
        };
    }
}
/**
 * Use this filter to filter numbers that are in the specified range.
 */
class RangeFilter extends Filter {
    /**
     * @return {?}
     */
    isActive() {
        return (this.min !== undefined && this.min !== null) || (this.max !== undefined && this.max !== null);
    }
    /**
     * @return {?}
     */
    toFilterRecord() {
        return {
            key: this.key,
            type: 'range',
            min: this.min,
            max: this.max
        };
    }
}
/**
 * Use this filter to filter dates. You can specify a start date, an end date or both.
 */
class DateFilter extends Filter {
    /**
     * @return {?}
     */
    isActive() {
        return (this.start !== undefined && this.start !== null) || (this.end !== undefined && this.end !== null);
    }
    /**
     * @return {?}
     */
    toFilterRecord() {
        return {
            key: this.key,
            type: 'range',
            min: this.start,
            max: this.end
        };
    }
}

var F = /*#__PURE__*/Object.freeze({
    Filter: Filter,
    ValueFilter: ValueFilter,
    MultiValueFilter: MultiValueFilter,
    RangeFilter: RangeFilter,
    DateFilter: DateFilter
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoFilterComponent {
    /**
     * @param {?} element
     */
    constructor(element) {
        this.toggle = new EventEmitter();
        this.visible = false;
        this.filterTypes = F;
        this.isDisabled = false;
        this.isAnchored = false;
        this.hasStyles = false;
        // Detect if used as a header filter in MatTable
        /** @type {?} */
        const p = element.nativeElement.parentElement;
        this.isHeaderFilter = p && (p.tagName === 'MAT-HEADER-CELL' || p.attributes.getNamedItem('mat-header-cell'));
        this.hasStyles = element.nativeElement.hasAttribute('pwo');
    }
    /**
     * @return {?}
     */
    get xPosition() {
        return this.align === 'right' ? 'before' : 'after';
    }
    /**
     * @param {?} filter
     * @param {?} filterType
     * @return {?}
     */
    is(filter, filterType) {
        return filter instanceof filterType;
    }
    /**
     * @return {?}
     */
    open() {
        this.toggle.next(true);
    }
    /**
     * @return {?}
     */
    close() {
        if (this.isAnchored) {
            this.toggle.next(false);
        }
        if (this.triggerMenu) {
            this.triggerMenu.closeMenu();
        }
    }
}
PwoFilterComponent.ɵfac = function PwoFilterComponent_Factory(t) { return new (t || PwoFilterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
PwoFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PwoFilterComponent, selectors: [["pwo-filter"], ["", "pwoFilter", ""]], viewQuery: function PwoFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MatMenuTrigger, 5);
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.triggerMenu = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuRef = _t.first);
    } }, inputs: { align: "align", filter: "filter", filterService: "filterService" }, outputs: { toggle: "toggle" }, ngContentSelectors: _c2, decls: 8, vars: 5, consts: [["class", "pointer", 3, "click", 4, "ngIf"], ["class", "pointer", 3, "matMenuTriggerFor", "click", 4, "ngIf"], ["mat-button", "", 3, "matMenuTriggerFor", "active", "menuOpened", 4, "ngIf"], ["filterIcon", ""], [3, "xPosition", "closed"], ["filterMenu", "matMenu"], ["class", "pwo-filter", 3, "pwo-styles", "click", 4, "ngIf"], [1, "pointer", 3, "click"], [4, "ngTemplateOutlet"], [1, "pointer", 3, "matMenuTriggerFor", "click"], ["mat-button", "", 3, "matMenuTriggerFor", "menuOpened"], [1, "spacer"], [4, "ngIf"], ["iconClosed", ""], ["class", "material-icons", 4, "ngIf"], [1, "material-icons"], ["iconOpened", ""], ["iconApplied", ""], [1, "pwo-filter", 3, "click"], [3, "filter", "filterService", "close", 4, "ngIf"], [3, "filter", "filterService", "close"]], template: function PwoFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵtemplate(0, PwoFilterComponent_span_0_Template, 2, 1, "span", 0);
        ɵngcc0.ɵɵtemplate(1, PwoFilterComponent_span_1_Template, 2, 2, "span", 1);
        ɵngcc0.ɵɵtemplate(2, PwoFilterComponent_button_2_Template, 4, 4, "button", 2);
        ɵngcc0.ɵɵtemplate(3, PwoFilterComponent_ng_template_3_Template, 3, 3, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(5, "mat-menu", 4, 5);
        ɵngcc0.ɵɵlistener("closed", function PwoFilterComponent_Template_mat_menu_closed_5_listener() { return ctx.visible = false; });
        ɵngcc0.ɵɵtemplate(7, PwoFilterComponent_div_7_Template, 4, 5, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAnchored);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isAnchored && ctx.isHeaderFilter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isAnchored && !ctx.isHeaderFilter);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("xPosition", ctx.xPosition);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.visible);
    } }, dependencies: function () { return [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.MatMenu, ɵngcc2.MatMenuTrigger, DateFilterComponent, MultiSelectFilterComponent, SingleSelectFilterComponent]; }, styles: [".pwo-filter[_ngcontent-%COMP%]{padding:8px}.pointer[_ngcontent-%COMP%]{cursor:pointer}button[_ngcontent-%COMP%]{display:flex;align-items:center}button[_ngcontent-%COMP%]   .spacer[_ngcontent-%COMP%]{display:none}.material-icons[_ngcontent-%COMP%]{margin-left:4px}  pwo-filter[pwo]{display:flex}  pwo-filter[pwo] button{width:100%;border:2px solid #2387aa;padding:6px 10px}  pwo-filter[pwo] button.active,   pwo-filter[pwo] button:hover{background-color:#2387aa;color:#fff}  pwo-filter[pwo] button>.spacer{flex:1;display:block!important}"] });
/** @nocollapse */
PwoFilterComponent.ctorParameters = () => [
    { type: ElementRef }
];
PwoFilterComponent.propDecorators = {
    triggerMenu: [{ type: ViewChild, args: [MatMenuTrigger,] }],
    align: [{ type: Input }],
    filter: [{ type: Input }],
    filterService: [{ type: Input }],
    toggle: [{ type: Output }],
    menuRef: [{ type: ViewChild, args: ['filterMenu',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoFilterComponent, [{
        type: Component,
        args: [{ selector: 'pwo-filter, [pwoFilter]', template: "<!-- FILTER ELEMENT -->\r\n<span class=\"pointer\" *ngIf=\"isAnchored\" (click)=\"visible = true; open()\">\r\n    <ng-container *ngTemplateOutlet=\"filterIcon\"></ng-container>\r\n</span>\r\n<span class=\"pointer\" *ngIf=\"!isAnchored && isHeaderFilter\" (click)=\"visible = true\"  [matMenuTriggerFor]=\"filterMenu\">\r\n    <ng-container *ngTemplateOutlet=\"filterIcon\"></ng-container>        \r\n</span>\r\n<button mat-button [matMenuTriggerFor]=\"filterMenu\" [class.active]=\"visible\" (menuOpened)=\"visible = true\" *ngIf=\"!isAnchored && !isHeaderFilter\">\r\n    <ng-content></ng-content>\r\n    <div class=\"spacer\"></div>\r\n    <ng-container *ngTemplateOutlet=\"filterIcon\"></ng-container>\r\n</button>\r\n\r\n<!-- FILTER ICON -->\r\n<ng-template #filterIcon>\r\n    <ng-container *ngIf=\"!visible && !filter.isApplied\">\r\n        <span #iconClosed>\r\n            <ng-content select=\"[icon-closed]\"></ng-content>\r\n        </span>\r\n        <i *ngIf=\"iconClosed.childNodes.length === 0\" class=\"material-icons\">keyboard_arrow_down</i>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"visible && !filter.isApplied\">\r\n        <span #iconOpened>\r\n            <ng-content select=\"[icon-opened]\"></ng-content>\r\n        </span>\r\n        <i *ngIf=\"iconOpened.childNodes.length === 0\" class=\"material-icons\">keyboard_arrow_up</i>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"filter.isApplied\">\r\n        <span #iconApplied>\r\n            <ng-content select=\"[icon-applied]\"></ng-content>\r\n        </span>\r\n        <!-- <i *ngIf=\"iconApplied.childNodes.length === 0\" class=\"icon--filter\"></i> -->\r\n        <i *ngIf=\"iconApplied.childNodes.length === 0\" class=\"material-icons\">filter_list</i>\r\n    </ng-container>\r\n</ng-template>\r\n\r\n<!-- FILTER COMPONENT -->\r\n<mat-menu #filterMenu=\"matMenu\" [xPosition]=\"xPosition\" (closed)=\"visible = false\">\r\n    <div class=\"pwo-filter\" [class.pwo-styles]=\"hasStyles\" (click)=\"$event.stopPropagation();\" *ngIf=\"visible\"> <!-- only render component if shown for better performance -->\r\n        <lib-date-filter *ngIf=\"is(filter, filterTypes.DateFilter)\" [filter]=\"filter\" [filterService]=\"filterService\" (close)=\"close()\">\r\n        </lib-date-filter>\r\n\r\n        <lib-single-select-filter *ngIf=\"is(filter, filterTypes.ValueFilter)\" [filter]=\"filter\" [filterService]=\"filterService\" (close)=\"close()\">\r\n        </lib-single-select-filter>\r\n\r\n        <lib-multi-select-filter *ngIf=\"is(filter, filterTypes.MultiValueFilter)\" [filter]=\"filter\" [filterService]=\"filterService\" (close)=\"close()\">\r\n        </lib-multi-select-filter>\r\n    </div>\r\n</mat-menu>", styles: [".pwo-filter{padding:8px}.pointer{cursor:pointer}button{display:flex;align-items:center}button .spacer{display:none}.material-icons{margin-left:4px}::ng-deep pwo-filter[pwo]{display:flex}::ng-deep pwo-filter[pwo] button{width:100%;border:2px solid #2387aa;padding:6px 10px}::ng-deep pwo-filter[pwo] button.active,::ng-deep pwo-filter[pwo] button:hover{background-color:#2387aa;color:#fff}::ng-deep pwo-filter[pwo] button>.spacer{flex:1;display:block!important}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { toggle: [{
            type: Output
        }], triggerMenu: [{
            type: ViewChild,
            args: [MatMenuTrigger]
        }], align: [{
            type: Input
        }], filter: [{
            type: Input
        }], filterService: [{
            type: Input
        }], menuRef: [{
            type: ViewChild,
            args: ['filterMenu']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DateFilterComponent {
    constructor() {
        this.close = new EventEmitter();
        this.index = 0;
    }
    /**
     * @return {?}
     */
    apply() {
        this.filter.start = this.startDate;
        this.filter.end = this.endDate;
        this.filterService.applyFilter(this.filter);
        this.close.next();
    }
    /**
     * @return {?}
     */
    clear() {
        this.startDate = undefined;
        this.endDate = undefined;
        this.apply();
    }
}
DateFilterComponent.ɵfac = function DateFilterComponent_Factory(t) { return new (t || DateFilterComponent)(); };
DateFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DateFilterComponent, selectors: [["lib-date-filter"]], viewQuery: function DateFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabs = _t.first);
    } }, inputs: { filter: "filter", filterService: "filterService" }, outputs: { close: "close" }, decls: 17, vars: 4, consts: [[1, "pwo-filter", "date-filter", 3, "selectedIndex", "selectedIndexChange"], ["tabGroup", ""], ["label", "Start"], [3, "selected", "selectedChange"], ["label", "End"], [3, "selected", "minDate", "selectedChange"], [1, "pwo-filter", "filter-apply"], ["mat-button", "", 3, "click"], [1, "material-icons"]], template: function DateFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-tab-group", 0, 1);
        ɵngcc0.ɵɵlistener("selectedIndexChange", function DateFilterComponent_Template_mat_tab_group_selectedIndexChange_0_listener($event) { return ctx.index = $event; });
        ɵngcc0.ɵɵelementStart(2, "mat-tab", 2)(3, "mat-calendar", 3);
        ɵngcc0.ɵɵlistener("selectedChange", function DateFilterComponent_Template_mat_calendar_selectedChange_3_listener($event) { return ctx.startDate = $event; })("selectedChange", function DateFilterComponent_Template_mat_calendar_selectedChange_3_listener() { return ctx.index = 1; });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(4, "mat-tab", 4)(5, "mat-calendar", 5);
        ɵngcc0.ɵɵlistener("selectedChange", function DateFilterComponent_Template_mat_calendar_selectedChange_5_listener($event) { return ctx.endDate = $event; });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(6, "div", 6)(7, "button", 7);
        ɵngcc0.ɵɵlistener("click", function DateFilterComponent_Template_button_click_7_listener() { return ctx.apply(); });
        ɵngcc0.ɵɵelementStart(8, "i", 8);
        ɵngcc0.ɵɵtext(9, "done");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span");
        ɵngcc0.ɵɵtext(11, "Apply");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(12, "button", 7);
        ɵngcc0.ɵɵlistener("click", function DateFilterComponent_Template_button_click_12_listener() { return ctx.clear(); });
        ɵngcc0.ɵɵelementStart(13, "i", 8);
        ɵngcc0.ɵɵtext(14, "clear");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "span");
        ɵngcc0.ɵɵtext(16, "Clear");
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("selectedIndex", ctx.index);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("selected", ctx.startDate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("selected", ctx.endDate)("minDate", ctx.startDate);
    } }, dependencies: [ɵngcc3.MatTabGroup, ɵngcc3.MatTab, ɵngcc4.MatCalendar], styles: [".pwo-filter.date-filter[_ngcontent-%COMP%]{min-width:250px}.pwo-filter.filter-apply[_ngcontent-%COMP%]{display:flex}  .pwo-filter .date-filter .mat-tab-label{min-width:0!important;width:50%}"] });
/** @nocollapse */
DateFilterComponent.ctorParameters = () => [];
DateFilterComponent.propDecorators = {
    tabs: [{ type: ViewChild, args: ['tabGroup',] }],
    filter: [{ type: Input }],
    filterService: [{ type: Input }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateFilterComponent, [{
        type: Component,
        args: [{ selector: 'lib-date-filter', template: "<!-- <mat-form-field>\r\n  <input matInput [matDatepicker]=\"pickerStart\" placeholder=\"Choose a start date\" [(ngModel)]=\"startDate\"\r\n    (dateChange)=\"apply()\">\r\n  <mat-datepicker-toggle matSuffix [for]=\"pickerStart\"></mat-datepicker-toggle>\r\n  <mat-datepicker #pickerStart></mat-datepicker>\r\n</mat-form-field>\r\n\r\n<mat-form-field>\r\n  <input matInput [matDatepicker]=\"pickerEnd\" placeholder=\"Choose an end date\" [(ngModel)]=\"endDate\"\r\n    (dateChange)=\"apply()\">\r\n  <mat-datepicker-toggle matSuffix [for]=\"pickerEnd\"></mat-datepicker-toggle>\r\n  <mat-datepicker #pickerEnd></mat-datepicker>\r\n</mat-form-field> -->\r\n\r\n<mat-tab-group #tabGroup class=\"pwo-filter date-filter\" [(selectedIndex)]=\"index\">\r\n  <mat-tab label=\"Start\">\r\n    <mat-calendar [(selected)]=\"startDate\" (selectedChange)=\"index = 1\"></mat-calendar>\r\n  </mat-tab>\r\n  <mat-tab label=\"End\">\r\n    <mat-calendar [(selected)]=\"endDate\" [minDate]=\"startDate\"></mat-calendar>\r\n  </mat-tab>\r\n</mat-tab-group>\r\n\r\n<div class=\"pwo-filter filter-apply\">\r\n  <button mat-button (click)=\"apply()\">\r\n    <i class=\"material-icons\">done</i>\r\n    <span>Apply</span>\r\n  </button>\r\n  <button mat-button (click)=\"clear()\">\r\n    <i class=\"material-icons\">clear</i>\r\n    <span>Clear</span>\r\n  </button>\r\n</div>", styles: [".pwo-filter.date-filter{min-width:250px}.pwo-filter.filter-apply{display:flex}::ng-deep .pwo-filter .date-filter .mat-tab-label{min-width:0!important;width:50%}"] }]
    }], function () { return []; }, { close: [{
            type: Output
        }], tabs: [{
            type: ViewChild,
            args: ['tabGroup']
        }], filter: [{
            type: Input
        }], filterService: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MultiSelectFilterComponent {
    constructor() {
        this.close = new EventEmitter();
        this.selection = new SelectionModel(true, []);
        this.allFilterValues = [];
        this.filterValues = [];
        this.searchTerm = '';
        this.allSelected = true;
        this.fewSelected = false;
        this.addToFilter = false;
        this.isLoading = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.selection.changed.subscribe((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const count = this.selection.selected.length;
            this.allSelected = count === this.filterValues.length;
            this.fewSelected = !this.allSelected && count > 0;
        }));
        this.init();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.selection.changed.unsubscribe();
    }
    /**
     * @return {?}
     */
    search() {
        /** @type {?} */
        const s = this.searchTerm.toLowerCase();
        this.filterValues = this.allFilterValues.filter((/**
         * @param {?} el
         * @return {?}
         */
        el => str(el).toLowerCase().includes(s)));
        this.selection.clear();
        this.selection.select(...this.filterValues);
        /**
         * @param {?} val
         * @return {?}
         */
        function str(val) {
            if (!val) {
                return '';
            }
            val = val + '';
            return val.length > 0 ? val : '(Empty)';
        }
    }
    /**
     * @return {?}
     */
    init() {
        this.isLoading = true;
        this.searchTerm = '';
        this.filterService.getFilterValues(this.filter).then((/**
         * @param {?} vals
         * @return {?}
         */
        vals => {
            this.allFilterValues = vals;
            this.filterValues = vals;
            this.selection.clear();
            if (!this.filter.isActive()) {
                // Filter not set means all values are selected
                this.selection.select(...this.filterValues);
            }
            else {
                // Restore selection with available options
                /** @type {?} */
                const sel = this.filter.selected.filter((/**
                 * @param {?} f
                 * @return {?}
                 */
                f => this.filterValues.includes(f)));
                this.selection.select(...sel);
            }
            this.isLoading = false;
        }));
    }
    /**
     * @return {?}
     */
    apply() {
        if (this.selection.selected.length === this.allFilterValues.length) {
            // Remove filter if all options are selected
            this.selection.clear();
        }
        else if (this.searchTerm.length > 0 && this.addToFilter) {
            // Select old selection
            this.selection.select(...this.filter.selected);
        }
        this.filter.selected = this.selection.selected;
        this.filterService.applyFilter(this.filter);
        this.close.next();
    }
    /**
     * @return {?}
     */
    toggleAll() {
        if (this.allSelected) {
            this.selection.clear();
        }
        else {
            this.selection.select(...this.filterValues);
        }
    }
}
MultiSelectFilterComponent.ɵfac = function MultiSelectFilterComponent_Factory(t) { return new (t || MultiSelectFilterComponent)(); };
MultiSelectFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultiSelectFilterComponent, selectors: [["lib-multi-select-filter"]], inputs: { filter: "filter", filterService: "filterService" }, outputs: { close: "close" }, decls: 14, vars: 6, consts: [[1, "pwo-filter", "filter-header"], [1, "input"], ["matInput", "", "autocomplete", "off", "placeholder", "Search for ...", 3, "ngModel", "ngModelChange"], ["mat-button", "", "mat-icon-button", "", "aria-label", "Clear", 3, "click"], [1, "material-icons"], ["class", "pwo-filter filter-values", 4, "ngIf"], ["class", "loader", 4, "ngIf"], [1, "pwo-filter", "filter-apply"], ["mat-button", "", 3, "disabled", "click"], [1, "pwo-filter", "filter-values"], [3, "checked", "indeterminate", "change"], [3, "ngModel", "ngModelChange", 4, "ngIf"], [3, "checked", "click", "change", 4, "ngFor", "ngForOf"], [3, "ngModel", "ngModelChange"], [3, "checked", "click", "change"], [1, "loader"], ["diameter", "60"]], template: function MultiSelectFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function MultiSelectFilterComponent_Template_input_ngModelChange_2_listener($event) { return ctx.searchTerm = $event; })("ngModelChange", function MultiSelectFilterComponent_Template_input_ngModelChange_2_listener() { return ctx.search(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function MultiSelectFilterComponent_Template_button_click_3_listener() { ctx.searchTerm = ""; return ctx.search(); });
        ɵngcc0.ɵɵelementStart(4, "i", 4);
        ɵngcc0.ɵɵtext(5, "close");
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵtemplate(6, MultiSelectFilterComponent_div_6_Template, 5, 5, "div", 5);
        ɵngcc0.ɵɵtemplate(7, MultiSelectFilterComponent_div_7_Template, 2, 0, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "div", 7)(9, "button", 8);
        ɵngcc0.ɵɵlistener("click", function MultiSelectFilterComponent_Template_button_click_9_listener() { return ctx.apply(); });
        ɵngcc0.ɵɵelementStart(10, "i", 4);
        ɵngcc0.ɵɵtext(11, "done");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "span");
        ɵngcc0.ɵɵtext(13, "Apply");
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchTerm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("visibility", ctx.searchTerm.length ? "visible" : "hidden");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLoading);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx.isLoading);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc5.MatCheckbox, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc7.MatInput, ɵngcc8.MatProgressSpinner], styles: [".pwo-filter.filter-header .input{display:flex;margin-bottom:8px}.pwo-filter.filter-header .input input{font-size:14px;border:none}.pwo-filter.filter-values{margin:15px 0}.pwo-filter.filter-apply{position:-webkit-sticky;position:sticky;bottom:0;background-color:#fff}.pwo-filter.filter-apply button{display:flex}.pwo-filter.filter-apply button span{margin-left:4px;margin-top:2px}.pwo-filter .mat-checkbox-layout{display:flex!important}.pwo-filter .mat-checkbox-layout .mat-checkbox-label{text-overflow:ellipsis;overflow:hidden;flex:1}.pwo-styles .filter-header .input{border:1px solid #cdd9e1;padding:4px}.loader{display:flex;justify-content:center;padding:10px}"], encapsulation: 2 });
/** @nocollapse */
MultiSelectFilterComponent.ctorParameters = () => [];
MultiSelectFilterComponent.propDecorators = {
    filter: [{ type: Input }],
    filterService: [{ type: Input }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiSelectFilterComponent, [{
        type: Component,
        args: [{ selector: 'lib-multi-select-filter', template: "<div class=\"pwo-filter filter-header\">\r\n  <div class=\"input\">\r\n    <input matInput autocomplete=\"off\" placeholder=\"Search for ...\" [(ngModel)]=\"searchTerm\" (ngModelChange)=\"search()\">\r\n    <button mat-button [style.visibility]=\"searchTerm.length ? 'visible' : 'hidden'\" mat-icon-button aria-label=\"Clear\"\r\n      (click)=\"searchTerm = ''; search()\">\r\n      <i class=\"material-icons\">close</i>\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"pwo-filter filter-values\" *ngIf=\"!isLoading\">\r\n  <mat-checkbox (change)=\"$event && toggleAll()\" [checked]=\"allSelected\" [indeterminate]=\"fewSelected\">\r\n    Select all {{ searchTerm.length > 0 ? 'search results' : '' }}\r\n  </mat-checkbox>\r\n\r\n  <mat-checkbox *ngIf=\"searchTerm.length > 0\" [(ngModel)]=\"addToFilter\">\r\n    Add selection to filter\r\n  </mat-checkbox>\r\n\r\n  <mat-checkbox\r\n    *ngFor=\"let f of filterValues\"\r\n    (click)=\"$event.stopPropagation()\"\r\n    (change)=\"$event ? selection.toggle(f) : null\"\r\n    [checked]=\"selection.isSelected(f)\"\r\n  >\r\n    {{ f }}\r\n  </mat-checkbox>\r\n</div>\r\n\r\n<div class=\"loader\" *ngIf=\"isLoading\">\r\n  <mat-spinner diameter=\"60\"></mat-spinner>\r\n</div>\r\n\r\n<div class=\"pwo-filter filter-apply\">\r\n  <button mat-button (click)=\"apply()\" [disabled]=\"isLoading\">\r\n    <i class=\"material-icons\">done</i>\r\n    <span>Apply</span>\r\n  </button>\r\n</div>\r\n", encapsulation: ViewEncapsulation.None, styles: [".pwo-filter.filter-header .input{display:flex;margin-bottom:8px}.pwo-filter.filter-header .input input{font-size:14px;border:none}.pwo-filter.filter-values{margin:15px 0}.pwo-filter.filter-apply{position:-webkit-sticky;position:sticky;bottom:0;background-color:#fff}.pwo-filter.filter-apply button{display:flex}.pwo-filter.filter-apply button span{margin-left:4px;margin-top:2px}.pwo-filter .mat-checkbox-layout{display:flex!important}.pwo-filter .mat-checkbox-layout .mat-checkbox-label{text-overflow:ellipsis;overflow:hidden;flex:1}.pwo-styles .filter-header .input{border:1px solid #cdd9e1;padding:4px}.loader{display:flex;justify-content:center;padding:10px}"] }]
    }], function () { return []; }, { close: [{
            type: Output
        }], filter: [{
            type: Input
        }], filterService: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SingleSelectFilterComponent {
    constructor() {
        this.close = new EventEmitter();
        this.allFilterValues = [];
        this.filterValues = [];
        this.searchTerm = '';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.init();
    }
    /**
     * @return {?}
     */
    init() {
        this.filterService.getFilterValues(this.filter).then((/**
         * @param {?} vals
         * @return {?}
         */
        vals => {
            this.allFilterValues = vals;
            this.search();
            this.selected = vals.find((/**
             * @param {?} el
             * @return {?}
             */
            el => el === this.filter.value));
        }));
    }
    /**
     * @return {?}
     */
    search() {
        /** @type {?} */
        const s = this.searchTerm.toLowerCase();
        this.filterValues = this.allFilterValues.filter((/**
         * @param {?} el
         * @return {?}
         */
        el => str(el).toLowerCase().includes(s)));
        if (this.filterValues.length === 1) {
            this.selected = this.filterValues[0];
        }
        /**
         * @param {?} val
         * @return {?}
         */
        function str(val) {
            if (!val) {
                return '';
            }
            val = val + '';
            return val.length > 0 ? val : '(Empty)';
        }
    }
    /**
     * @return {?}
     */
    apply() {
        this.filter.value = this.selected;
        this.filterService.applyFilter(this.filter);
        this.close.next();
    }
    /**
     * @return {?}
     */
    clear() {
        this.selected = undefined;
        this.searchTerm = '';
        this.apply();
    }
}
SingleSelectFilterComponent.ɵfac = function SingleSelectFilterComponent_Factory(t) { return new (t || SingleSelectFilterComponent)(); };
SingleSelectFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SingleSelectFilterComponent, selectors: [["lib-single-select-filter"]], inputs: { filter: "filter", filterService: "filterService" }, outputs: { close: "close" }, decls: 14, vars: 5, consts: [[1, "pwo-filter", "filter-header"], [1, "input"], ["matInput", "", "autocomplete", "off", "placeholder", "Search for ...", 3, "ngModel", "ngModelChange", "keyup.enter"], ["mat-button", "", "mat-icon-button", "", "aria-label", "Clear", 3, "click"], [1, "material-icons"], ["class", "pwo-filter filter-values", 4, "ngIf"], [1, "pwo-filter", "filter-apply"], ["mat-button", "", 3, "click"], ["mat-button", "", 3, "click", 4, "ngIf"], [1, "pwo-filter", "filter-values"], [3, "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function SingleSelectFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function SingleSelectFilterComponent_Template_input_ngModelChange_2_listener($event) { return ctx.searchTerm = $event; })("ngModelChange", function SingleSelectFilterComponent_Template_input_ngModelChange_2_listener() { return ctx.search(); })("keyup.enter", function SingleSelectFilterComponent_Template_input_keyup_enter_2_listener() { return ctx.selected && ctx.apply(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function SingleSelectFilterComponent_Template_button_click_3_listener() { ctx.searchTerm = ""; return ctx.search(); });
        ɵngcc0.ɵɵelementStart(4, "i", 4);
        ɵngcc0.ɵɵtext(5, "close");
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵtemplate(6, SingleSelectFilterComponent_div_6_Template, 3, 2, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "div", 6)(8, "button", 7);
        ɵngcc0.ɵɵlistener("click", function SingleSelectFilterComponent_Template_button_click_8_listener() { return ctx.apply(); });
        ɵngcc0.ɵɵelementStart(9, "i", 4);
        ɵngcc0.ɵɵtext(10, "done");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "span");
        ɵngcc0.ɵɵtext(12, "Apply");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(13, SingleSelectFilterComponent_button_13_Template, 5, 0, "button", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchTerm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("visibility", ctx.searchTerm.length ? "visible" : "hidden");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.filterValues);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngIf", ctx.filter.isApplied);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc9.MatRadioGroup, ɵngcc9.MatRadioButton, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc7.MatInput], styles: [".pwo-filter.filter-header[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{display:flex;margin-bottom:8px}.pwo-filter.filter-header[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{font-size:14px}.pwo-filter.filter-values[_ngcontent-%COMP%]   .mat-radio-group[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin:15px 0}.pwo-filter.filter-values[_ngcontent-%COMP%]   .mat-radio-group[_ngcontent-%COMP%]   .mat-radio-button[_ngcontent-%COMP%]{margin:5px;font-size:14px}.pwo-filter.filter-apply[_ngcontent-%COMP%], .pwo-filter.filter-apply[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:flex}.pwo-filter.filter-apply[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-left:4px;margin-top:2px}.pwo-styles[_ngcontent-%COMP%]   .filter-header[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{border:1px solid #cdd9e1;padding:4px}  .pwo-filter .mat-radio-button .mat-radio-label{max-width:100%}  .pwo-filter .mat-radio-button .mat-radio-label .mat-radio-label-content{text-overflow:ellipsis;overflow-x:hidden}"] });
/** @nocollapse */
SingleSelectFilterComponent.ctorParameters = () => [];
SingleSelectFilterComponent.propDecorators = {
    filter: [{ type: Input }],
    filterService: [{ type: Input }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SingleSelectFilterComponent, [{
        type: Component,
        args: [{ selector: 'lib-single-select-filter', template: "<div class=\"pwo-filter filter-header\">\r\n  <div class=\"input\">\r\n    <input matInput autocomplete=\"off\" placeholder=\"Search for ...\" [(ngModel)]=\"searchTerm\" (ngModelChange)=\"search()\" (keyup.enter)=\"selected && apply()\">\r\n    <button mat-button [style.visibility]=\"searchTerm.length ? 'visible' : 'hidden'\" mat-icon-button aria-label=\"Clear\"\r\n      (click)=\"searchTerm = ''; search()\">\r\n      <i class=\"material-icons\">close</i>\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"filterValues\" class=\"pwo-filter filter-values\">\r\n  <mat-radio-group [(ngModel)]=\"selected\">\r\n    <mat-radio-button *ngFor=\"let f of filterValues\" [value]=\"f\">\r\n      {{ filter.transform(f) }}\r\n    </mat-radio-button>\r\n  </mat-radio-group>\r\n</div>\r\n\r\n<div class=\"pwo-filter filter-apply\">\r\n  <button mat-button (click)=\"apply()\">\r\n    <i class=\"material-icons\">done</i>\r\n    <span>Apply</span>\r\n  </button>\r\n  <button *ngIf=\"filter.isApplied\" mat-button (click)=\"clear()\">\r\n    <i class=\"material-icons\">clear</i>\r\n    <span>Clear</span>\r\n  </button>\r\n</div>\r\n", styles: [".pwo-filter.filter-header .input{display:flex;margin-bottom:8px}.pwo-filter.filter-header .input input{font-size:14px}.pwo-filter.filter-values .mat-radio-group{display:flex;flex-direction:column;margin:15px 0}.pwo-filter.filter-values .mat-radio-group .mat-radio-button{margin:5px;font-size:14px}.pwo-filter.filter-apply,.pwo-filter.filter-apply button{display:flex}.pwo-filter.filter-apply button span{margin-left:4px;margin-top:2px}.pwo-styles .filter-header .input{border:1px solid #cdd9e1;padding:4px}::ng-deep .pwo-filter .mat-radio-button .mat-radio-label{max-width:100%}::ng-deep .pwo-filter .mat-radio-button .mat-radio-label .mat-radio-label-content{text-overflow:ellipsis;overflow-x:hidden}"] }]
    }], function () { return []; }, { close: [{
            type: Output
        }], filter: [{
            type: Input
        }], filterService: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RangeFilterComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
RangeFilterComponent.ɵfac = function RangeFilterComponent_Factory(t) { return new (t || RangeFilterComponent)(); };
RangeFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RangeFilterComponent, selectors: [["lib-range-filter"]], decls: 2, vars: 0, template: function RangeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " range-filter works!\n");
        ɵngcc0.ɵɵelementEnd();
    } } });
/** @nocollapse */
RangeFilterComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RangeFilterComponent, [{
        type: Component,
        args: [{ selector: 'lib-range-filter', template: "<p>\r\n  range-filter works!\r\n</p>\r\n" }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoFilterAnchorDirective extends MatMenuTrigger {
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!this.filterComponent) {
            throw new Error('pwoFilterAnchor must have PwoFilterComponent (<pwo-filter>) as a child!');
        }
        this.filterComponent.isAnchored = true;
        this.menu = this.filterComponent.menuRef;
        this.filterComponent.toggle.subscribe((/**
         * @param {?} state
         * @return {?}
         */
        (state) => {
            if (this.menuOpen !== state) {
                if (state) {
                    this.openMenu();
                }
                else {
                    this.closeMenu();
                }
            }
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.filterComponent.toggle.unsubscribe();
    }
}
PwoFilterAnchorDirective.ɵfac = /*@__PURE__*/ function () { let ɵPwoFilterAnchorDirective_BaseFactory; return function PwoFilterAnchorDirective_Factory(t) { return (ɵPwoFilterAnchorDirective_BaseFactory || (ɵPwoFilterAnchorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(PwoFilterAnchorDirective)))(t || PwoFilterAnchorDirective); }; }();
PwoFilterAnchorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PwoFilterAnchorDirective, selectors: [["", "pwoFilterAnchor", ""]], contentQueries: function PwoFilterAnchorDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, PwoFilterComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.filterComponent = _t.first);
    } }, exportAs: ["matMenuTrigger"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
PwoFilterAnchorDirective.propDecorators = {
    filterComponent: [{ type: ContentChild, args: [PwoFilterComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoFilterAnchorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: '[pwoFilterAnchor]',
                // host: {
                //   'aria-haspopup': 'true',
                //   '[attr.aria-expanded]': 'menuOpen || null',
                //   '(mousedown)': '_handleMousedown($event)',
                //   '(keydown)': '_handleKeydown($event)',
                //   '(click)': '_handleClick($event)',
                // },
                exportAs: 'matMenuTrigger'
            }]
    }], null, { filterComponent: [{
            type: ContentChild,
            args: [PwoFilterComponent]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoFilterCloudModule {
}
PwoFilterCloudModule.ɵfac = function PwoFilterCloudModule_Factory(t) { return new (t || PwoFilterCloudModule)(); };
PwoFilterCloudModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PwoFilterCloudModule });
PwoFilterCloudModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        MatMenuModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        MatButtonToggleModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        ReactiveFormsModule,
        MatTableModule,
        MatChipsModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatDatepickerModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoFilterCloudModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatMenuModule,
                    MatCheckboxModule,
                    MatRadioModule,
                    FormsModule,
                    MatButtonToggleModule,
                    MatFormFieldModule,
                    MatSelectModule,
                    MatInputModule,
                    ReactiveFormsModule,
                    MatTableModule,
                    MatChipsModule,
                    MatDialogModule,
                    MatProgressSpinnerModule,
                    MatTabsModule,
                    MatDatepickerModule,
                ],
                exports: [
                    PwoFilterComponent,
                    PwoFilterAnchorDirective
                ],
                declarations: [
                    PwoFilterComponent,
                    DateFilterComponent,
                    MultiSelectFilterComponent,
                    SingleSelectFilterComponent,
                    RangeFilterComponent,
                    PwoFilterAnchorDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PwoFilterCloudModule, { declarations: function () { return [PwoFilterComponent, DateFilterComponent, MultiSelectFilterComponent, SingleSelectFilterComponent, RangeFilterComponent, PwoFilterAnchorDirective]; }, imports: function () { return [CommonModule,
        MatMenuModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        MatButtonToggleModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        ReactiveFormsModule,
        MatTableModule,
        MatChipsModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatDatepickerModule]; }, exports: function () { return [PwoFilterComponent, PwoFilterAnchorDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { PwoFilterCloudService, PwoFilterCloudModule, Filter, ValueFilter, MultiValueFilter, RangeFilter, DateFilter, PwoFilterComponent, PwoFilterAnchorDirective as ɵa, DateFilterComponent as ɵb, MultiSelectFilterComponent as ɵc, RangeFilterComponent as ɵe, SingleSelectFilterComponent as ɵd };


